// extracted by mini-css-extract-plugin
export default {"item":"qpmFg8iWm6oRAPrZWfDm","address":"lXsM8YaqrikazhiLTng9","value":"mQf6MfQbS_R1rPNJUErc","valueAddress":"HT0TB2XEwG3r3r12ICs2"};